import { Container, Form, Row, Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import ModalConferma from "../../Utilities/ModalConferma";
import impostazioniComuneServiceInstance from "../../../services/ImpostazioniComuneService";

export default function ImpostazioniModuli(props) {
    // Riferimento al form (posizione 0)
    let ref = useRef([]);
    const [validated, setValidated] = useState(false);

    // Stati per la gestione dei modali di notifica
    const [mostraModalOk, setMostraModalOk] = useState(false)
    const [mostraModalFailed, setMostraModalFailed] = useState(false)
    const [mostraModalCancelOk, setMostraModalCancelOk] = useState(false)

    //Stati per le label dei moduli per cui la label è modificabile
    const [labelBilanci, setLabelBilanci] = useState("")
    const [labelIniziative, setLabelIniziative] = useState("")
    const [labelSondaggi, setLabelSondaggi] = useState("")

    // useEffect che imposta gli stati in base ai valori presenti nel database.
    // I valori vengono letti dall'oggetto 'props.comune.impostazioniComune' se presenti, altrimenti vengono inizializzati a "" (stringa vuota).  
    useEffect(() => {
        setLabelBilanci(
            props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloBilanci
                ? props.comune.impostazioniComune.imcLabelModuloBilanci
                : ""
        );
        setLabelIniziative(
            props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloIniziative
                ? props.comune.impostazioniComune.imcLabelModuloIniziative
                : ""
        );
        setLabelSondaggi(
            props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloSondaggi
               ? props.comune.impostazioniComune.imcLabelModuloSondaggi
           : ""   
        );
    }, [props.comune])

    /**
     * - Salva le label aggiornate nel database
    * - Prepara un oggetto con le nuove impostazioniComune
    * - Gestisce le risposte e mostra i modali di successo o fallimento
    */
    const handleSubmit = () => {
        // Creazione dell'oggetto contenente le impostazioni aggiornate
        let impostazioniComune = {
            comune: {
                comId: props.comune.comId
            },
            ...props.comune.impostazioniComune,
            "imcLabelModuloBilanci": labelBilanci,
            "imcLabelModuloIniziative": labelIniziative,
            "imcLabelModuloSondaggi": labelSondaggi
        }

        // Nasconde il modal di conferma annullamento
        setMostraModalCancelOk(false)
        // Effettua una richiesta al servizio per aggiornare le impostazioni nel database
        impostazioniComuneServiceInstance.aggiornaImpostazioni(impostazioniComune)
            .then(() => {
                props.setRicaricaComune(true)
                setMostraModalOk(true)
            })
            .catch(() => {
                setMostraModalFailed(true)
            })

    }

    /**
     * Chiude il modal di conferma salvataggio.
     */
    const closeOkModal = () => {
        setMostraModalOk(false)
    }

    /**
     * Chiude il modal di errore.
     */
    const closeOkFailed = () => {
        setMostraModalFailed(false)
    }

     //Verifica se i dati sono corretti
    const checkForm = () => {
        setValidated(true);
        if (ref.checkValidity() === true)
            setMostraModalCancelOk(true)
    }

    return (
        <>
            <Container fluid="md">
                <Form noValidate validated={validated} onSubmit={handleSubmit} ref={el => ref = el} >
                    {
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloBilanciAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo bilanci partecipativi:</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo bilanci partecipativi"
                                    value={labelBilanci}
                                    onChange={(ev) => setLabelBilanci(ev.target.value)}
                                />
                            </Form.Group>
                        </Row>
                    }

{
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloIniziativeAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo iniziative:</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo iniziative"
                                    value={labelIniziative}
                                    onChange={(ev) => setLabelIniziative(ev.target.value)}
                                />
                            </Form.Group>
                        </Row>
                    }
                    {
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSondaggiAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo sondaggi:</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo sondaggi"
                                    value={labelSondaggi}
                                    onChange={(ev) => setLabelSondaggi(ev.target.value)}
                                />
                            </Form.Group>
                        </Row>
                    }

                    {
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloPetizioniAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo petizioni: &nbsp;</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo petizioni"
                                    defaultValue={props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloPetizioni}
                                    disabled
                                />
                            </Form.Group>
                        </Row>

                    }

                    {
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloReferendumAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo referendum: &nbsp;</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo petizioni"
                                    defaultValue={props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloReferendum}
                                    disabled
                                />
                            </Form.Group>
                        </Row>
                    }
                    {
                        props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSegnalazioniAttivo &&
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label column sm="4">
                                    <strong>Label modulo segnalazioni: &nbsp;</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Inserisci la nuova label per il modulo petizioni"
                                    defaultValue={props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcLabelModuloSegnalazioni}
                                    disabled
                                />
                            </Form.Group>

                        </Row>
                    }
                </Form>
                <Container className="d-flex justify-content-end w-90 p-0 pt-3 pb-3">
                    <Button onClick={checkForm}>Aggiorna</Button>
                </Container>
            </Container >

            <ModalConferma
                mostra={mostraModalOk}
                setMostra={setMostraModalOk}
                mode="success"
                titolo="Salvataggio impostazioni"
                messaggio="Impostazioni salvate con successo"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={closeOkModal}
            />

            <ModalConferma
                mostra={mostraModalFailed}
                setMostra={setMostraModalFailed}
                mode="error"
                titolo="Salvataggio impostazioni"
                messaggio="Errore nel salvataggio delle impostazioni"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={closeOkFailed}
            />

            <ModalConferma
                mostra={mostraModalCancelOk}
                setMostra={setMostraModalCancelOk}
                mode="primary"
                titolo="Salvataggio impostazioni"
                messaggio="Confermi il salvataggio delle impostazioni?"
                bodyAlign="text-center"
                btnAnnulla="No, annulla"
                btnConferma="Sì, salva"
                azioneConferma={handleSubmit}
            />
        </>
    )
}